"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shouldRenderAsLink = exports.normalizeCategory = void 0;

var shouldRenderAsLink = function shouldRenderAsLink(item, isHamburgerList) {
  var hasChildren = item.children.length > 0;
  var hasUrl = item.url && item.url !== '#';
  if (!hasUrl) return false;
  if (!hasChildren) return true;
  if (isHamburgerList) return true;
  return false;
};

exports.shouldRenderAsLink = shouldRenderAsLink;

var normalizeCategory = function normalizeCategory(item) {
  var _item$children, _item$url;

  var parentId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var fallbackId = -1;
  var parsedId = typeof item.id === 'number' ? item.id : Number.parseInt(String(item.id), 10);
  var id = Number.isNaN(parsedId) ? fallbackId-- : parsedId;
  var children = ((_item$children = item.children) !== null && _item$children !== void 0 ? _item$children : []).map(function (child) {
    return normalizeCategory(child, id);
  });
  var visibleTopicsCount = typeof item.visibleTopicsCount === 'number' ? item.visibleTopicsCount // eslint-disable-line @typescript-eslint/no-non-null-assertion
  : children.length;
  return {
    id: id,
    title: item.title,
    url: (_item$url = item.url) !== null && _item$url !== void 0 ? _item$url : '#',
    external: Boolean(item.external),
    parentId: parentId,
    children: children,
    visibleTopicsCount: visibleTopicsCount
  };
};

exports.normalizeCategory = normalizeCategory;